<!--
 * @LastEditors: wuyanfeiying
 * @desc: 项目顶部导航栏
-->
<template>
  <div>
    <div class="nav-header">
    <img style="margin-right: 20px;" @click="goTag" src="../../build/观照.svg" width="90" height="70">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      text-color="#001529"
      mode="horizontal"
      :router="true"
      @select="handleSelect">
      <el-menu-item v-if="!screenMinSM" index="1" :route="{path:'/dailyBackFour'}">回测</el-menu-item>
      <el-menu-item v-if="!screenMinMd" index="3" :route="{path:'/timeSeries'}">数据库</el-menu-item>
      <el-menu-item v-if="!screenMinMd" index="7" :route="{path:'/policyLibrary'}">策略库</el-menu-item>
      <el-menu-item v-if="!screenMinMd"  index="2" :route="{path:'/customLabel'}">资产池</el-menu-item>
      <el-menu-item v-if="!screenMinLG" index="8" :route="{path:'/research'}">研究库</el-menu-item>
      <el-menu-item v-if="!screenMinSM" index="11" :route="{path:'/gptLaboratory'}">GPT实验室</el-menu-item>
      <el-menu-item v-if="!screenMinSM" index="12" :route="{path:'/factorBase'}">因子库</el-menu-item>
      <el-menu-item v-if="!screenMinSM" index="13" :route="{path:'/infoCollector'}">信息收集器</el-menu-item>
      <el-menu-item v-if="!screenMinXL && showRiskMenu" index="10" :route="{path:'/riskControlSystem'}" >风控</el-menu-item>
      <el-menu-item index="5" :route="{path:'/administratorMain'}" v-if="!screenMinXL && userName !== 'guanzhao' && (is_admin === 'true' || is_super_admin === 'true')" >后台管理</el-menu-item>

      <el-submenu v-if="screenMinXL" index="more">
        <template slot="title">更多</template>
        <el-menu-item v-if="screenMinSM" index="1" :route="{path:'/dailyBackFour'}" class="more-menu-item">回测</el-menu-item>
        <el-menu-item v-if="screenMinSM" index="11" :route="{path:'/gptLaboratory'}" class="more-menu-item">GPT实验室</el-menu-item>
        <el-menu-item v-if="screenMinSM" index="12" :route="{path:'/factorBase'}" class="more-menu-item">因子库</el-menu-item>
        <el-menu-item v-if="screenMinSM" index="13" :route="{path:'/infoCollector'}"  class="more-menu-item">信息收集器</el-menu-item>
        <el-menu-item v-if="screenMinMd" index="3" :route="{path:'/timeSeries'}" class="more-menu-item">数据库</el-menu-item>
        <el-menu-item v-if="screenMinMd" index="7" :route="{path:'/policyLibrary'}" class="more-menu-item">策略库</el-menu-item>
        <el-menu-item v-if="screenMinMd"  index="2" :route="{path:'/customLabel'}" class="more-menu-item">资产池</el-menu-item>
        <el-menu-item v-if="screenMinLG" index="8" :route="{path:'/research'}" class="more-menu-item">研究库</el-menu-item>
        <el-menu-item v-if="showRiskMenu" index="10" :route="{path:'/riskControlSystem'}" class="more-menu-item" >风控</el-menu-item>
        <el-menu-item class="more-menu-item" index="5" :route="{path:'/administratorMain'}" v-if="userName !== 'guanzhao' && (is_admin === 'true' || is_super_admin === 'true')" >后台管理</el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="nav-user-info">
      <div class="circle" @click="gotoUserInfo">{{userNameFirst}}</div>
      <el-badge style="margin: 0px 5px;" :is-dot="isDot" class="item"><i @click="goToNotification()" class="cursor el-icon-bell bold"></i></el-badge>
      <i class="cursor" style="transform: rotate(30deg);" @click="handleCopy($event)"><img src="../assets/地球.svg"></i>
    </div>
    </div>

    <el-dialog
      class="mobile-hidden"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      top="25vh">
      <div style="text-align: center;">
        <i style="font-size: 60px;color: rgb(19, 206, 102);" class="el-icon-circle-check"></i>
        <h1>链接复制成功!</h1>
        <span>如需使用其它浏览器登录，请打开浏览器粘贴访问。该链接存在账户泄密风险，请勿将链接分享他人！</span>
      </div>
    </el-dialog>

    <!-- 移动端展示的导航栏 -->
    <!-- <NavMobile class="pc-hidden" :activeIndex="activeIndex" /> -->
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { getRequest, postRequest } from '@/api/dailyBackTest.js'

import clip from '@/utils/clipboard'

// 自定义子组件
import NavMobile from './Mobile/Nav/index.vue'

export default {
  name: 'LyNav',

  components: { NavMobile },

  data () {
    return {
      activeIndex: this.$route.name,
      subscriptionList: [],
      management: [],
      manage: false,
      visible: false,
      gridData: [],
      tagInfo: {},
      is_admin: false,
      is_super_admin: false,
      mytoken: '',
      dialogVisible: false,
      isDot: false,
      commentNum: 0,
      likeNum: 0,
      userName: '',
      userNames: [
        'gaog',
        'chenwj',
        'qiaoss',
        'guoyb',
        'guanzhao',
        '董旭',
        'pooh',
        '青妩',
        '赵爱洁',
        '测试账户',
        '王木木',
        '褚'
      ],
      showRiskMenu: true
    }
  },
  computed: {
    ...mapGetters(['screenMinXL', 'screenMinLG', 'screenMinMd', 'screenMinSM']),
    ...mapState(['Authorization', 'curScreenSize']),
    userNameFirst () {
      let firstChar = this.userName ? this.userName.charAt(0) : '观'

      // 如果是英文字符，转为大写
      if (/[a-zA-Z]/.test(firstChar)) {
        firstChar = firstChar.toUpperCase()
      }

      return firstChar
    }
  },

  methods: {
    ...mapMutations(['changeLogin']),
    handleCopy (event) {
      var test = window.location.protocol
      var test1 = window.location.host + '/#/login?token='
      var text = test + '//' + test1 + this.mytoken
      text = text.toString()
      // console.log(text)
      clip(text, event)
      this.dialogVisible = true
    },

    goToNotification () {
      this.$router.push('/notification')
    },
    getDate () {
      const myDate = new Date()
      const year = myDate.getFullYear()
      const month = myDate.getMonth() + 1
      const date = myDate.getDate()
      var time =
        year.toString() +
        this.convert(month).toString() +
        this.convert(date).toString()
      return time
    },
    convert (val) {
      return val < 10 ? '0' + val : val
    },
    getNewNews () {
      var _this = this
      if (localStorage.getItem('Authorization') === 'null' || !localStorage.getItem('Authorization')) {
        return
      }
      getRequest('/notification/new_count').then(function (x) {
        setTimeout(() => {
          _this.getNewNews()
        }, 30000)
        if (!x.data.message) {
          _this.isDot = false
          if (x.data.data.comment > 0) {
            _this.isDot = true
          }
          if (x.data.data.like > 0) {
            _this.isDot = true
          }
          if (_this.commentNum !== x.data.data.comment || _this.likeNum !== x.data.data.like) {
            console.log('test')
            _this.likeNum = x.data.data.like
            _this.commentNum = x.data.data.comment
            _this.bus.$emit('comment', x.data.data.comment, x.data.data.like)
          }
        }
      })
      let time = this.getDate()
      if (time - this.$store.state.loginDate > 5) {
        this.tokenLogin(time)
      }
    },
    tokenLogin (time) {
      // console.log('tokenLogin')
      var _this = this
      postRequest('/user/refresh_token').then(function (data) {
        _this.accessLogin = false
        if (data.data.code !== 0) {
          _this.$message({
            message: data.data.message
          })
        } else if (data.data.code === 0) {
          sessionStorage.userName = data.data.data.userName
          localStorage.userName = data.data.data.userName
          sessionStorage.is_admin = data.data.data.is_admin
          localStorage.is_admin = data.data.data.is_admin
          sessionStorage.is_super_admin = data.data.data.is_super_admin
          localStorage.is_super_admin = data.data.data.is_super_admin
          sessionStorage.organization = data.data.data.organization
          localStorage.organization = data.data.data.organization
          _this.userToken = 'Bearer ' + data.data.data.token
          // 将用户token保存到vuex中
          _this.changeLogin({ Authorization: _this.userToken, loginDate: time, userName: data.data.data.userName })
        }
      })
    },
    goTag () {
      this.$router.push({ path: '/dailyBackFour' })
      this.bus.$emit('prePage', '1')
    },
    handleSelect (key, keyPath) {
      this.bus.$emit('prePage', key)
    },
    setCurrentRoute () {
      this.activeIndex = this.$route.name // 关键   通过他就可以监听到当前路由状态并激活当前菜单
    },

    // 前往用户管理页面
    gotoUserInfo () {
      this.$router.push({ path: '/userInfo' })
    }
  },
  mounted () {
    var test = window.location.search
    let index = test.indexOf('access_token')
    if (index > -1) {
      this.$router.push({path: '/login'})
      return
    }
    this.mytoken = localStorage.getItem('Authorization')
    var l = localStorage.getItem('userName')
    if (l !== null) {
      this.userName = l
      this.showRiskMenu = this.userNames.indexOf(this.userName) > -1
    }
    this.is_admin = localStorage.getItem('is_admin')
    this.is_super_admin = localStorage.getItem('is_super_admin')
    this.setCurrentRoute()
    if (this.$route.name !== '13') {
      this.getNewNews()
    }
    var _this = this
    this.bus.$on('isDot', (value) => {
      _this.isDot = value
      _this.likeNum = 0
      _this.commentNum = 0
    })
  },

  watch: {
    $route () {
      this.setCurrentRoute()
    }
  }
}
</script>
<style scoped>
  .el-menu--horizontal>.el-menu-item, .el-menu--horizontal>.el-submenu >>> .el-submenu__title  {
    float: left;
    height: 70px;
    line-height: 70px;
    border-bottom: 0px;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    color: #B3292C !important;
    background-color: rgba(179, 41, 44, 0.1) !important;
    border-bottom: 0px;
  }
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: rgba(179, 41, 44, 0.1) !important;
    color: #B3292C !important;
  }
  .el-menu-demo {
    font-weight:bold;
    text-align: left;
    width: 100%;
  }
  .el-menu-item {
    font-size: 18px;
    color: #001529;
    padding: 0 15px;
  }
  .el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: rgba(179, 41, 44, 0.1);
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

.nav-header{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  padding: 0px 20px;
  background: #ffffff;
}
.nav-user-info{
  display: flex;
  align-items: center;
}

.circle {
  width: 36px;
  height: 36px;
  background-color: #b7242a;  /* 浅绿色背景 */
  border: 2px solid #a32125;  /* 深绿色边框 */
  border-radius: 50%;  /* 圆形 */
  display: flex;  /* 使用 flex 布局将文本居中 */
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;  /* 选择适合显示中文的字体 */
  font-size: 18px;
  color: #FFFFFF;  /* 字体颜色 */
  margin-left: 10px;
  cursor: pointer;
}

.more-menu-item {
  width: 100%;margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navi.vue